module.exports = __webpack_public_path__ + "img/far-pause-circle.08c1116f.svg";